module.exports = __webpack_public_path__ + "img/1F1EB-1F1F0.fa48a38e.svg";